import params from 'Cloud/Application/Params';
import browser from 'Cloud/browser';
import { IS_ANDROID_MOBILE, IS_IOS_MOBILE } from 'reactApp/appHelpers/configHelpers';

const mobileType = params.getParam('MOBILE_BROWSER');
const isPhone = !!params.getParam('PHONE_BROWSER');
const isWebview = !!params.getParam('IS_WEBVIEW');
const isHuawei = params.getParam('EMORB_VENDOR') === 'Huawei';

const getMobileType = () => (IS_ANDROID_MOBILE ? 'ANDROID' : IS_IOS_MOBILE ? 'IOS' : mobileType);
const isMobile = () => !!getMobileType();

export const EnvironmentSelectors = {
    isMobile,
    getMobileType,
    isHuawei: () => isHuawei,
    isPhone: () => isPhone,
    isWebview: () => isWebview,
    isIE: () => browser.isIE(),
    isIpadOs: () => browser.isIpadOs(),
    isMac: () => browser.isMac(),
    getIOsVersion: () => browser.getIOsVersion(),
};
